export const roundDecimal = (number, precision = 2) => {
  const multiplyFactor = Math.pow(10, precision);
  return Math.round(multiplyFactor * number) / multiplyFactor;
};

/**
 * [get the average of certain numbers]
 * @param  {[Array]} numbers
 * @return {[Number]}
 */
export const average = (numbers, precision) => {
  const sum = numbers.reduce((a, b) => a + b, 0);
  return roundDecimal(sum / numbers.length, precision);
};

/**
 * [get the min value of certain numbers]
 * @param  {[Array]} numbers
 * @return {[Number]}
 */
export const min = (numbers) => {
  const minValue = numbers.sort((a, b) => a > b)[0];
  return minValue;
};

/**
 * [get the max value of certain numbers]
 * @param  {[Array]} numbers
 * @return {[Number]}
 */
export const max = (numbers) => {
  const maxValue = numbers.sort((a, b) => a < b)[0];
  return maxValue;
};



/** WEBPACK FOOTER **
 ** ./core_components/DataLayer/MarkerClusterLayer/utils.js
 **/